import { DistrictContent } from "../../components/boundary"

export default function District () {

  return (

    <>
        <DistrictContent/>
    </>

  )

}